import api from './index'

class BonusService {
	fetchBonus() {
		return api.get('/promotions')
	}

	addBonus(data) {
		return api.post('/promotions', data)
	}
	editBonus(data) {
		return api.post(`/promotions/${data.key}`, data)
	}
	deleteBonusImage(key) {
		return api.delete(`/promotions/${key}/image`)
	}
	deleteBonus(key) {
		return api.delete(`/promotions/${key}`)
	}

	fetchSummary(params) {
		return api.get('/promotions/summary', { params })
	}
	fetchReport(params) {
		return api.get('/promotions/report', { params })
	}
}

export default new BonusService()
